import PropTypes from 'prop-types';
import React/*, { useState }*/ from 'react';

import styled from 'styled-components';

import { /*faSearch, faCog,*/ faSync } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BlackInverseButton from "../../ui/BlackInverseButton";
import ConfigureIcon from "../../img/toolbar-columnoption-light.svg";
import ConfigureIconDark from "../../img/toolbar-columnoption-dark.svg";
import ConfigureIcon2 from "../../img/columnoption_light.svg";
import ConfigureIconDark2 from "../../img/columnoption_dark.svg";
import CloseButton from '../../ui/CloseButton';
import IconButton, { RefreshIconButton } from '../../ui/IconButton';

const Screen = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background-color: white;
  height: 64px;
  padding-left: 15px;
  padding-right: 20px;

  .ifms-list-screen-right {
    align-self: center;
    margin-left:auto;
  }

  h2 {
    color: #000000;
    font-family: Arial;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    margin: 0;
    padding: 0;
    margin-block-end: 0;
    width: 150px;
  }

  .search-content {
    position: relative;
    margin-left: 12px;
    margin-right: 12px;

    .search-filter {
      top: 0;
      left: 0;
      display: block;
      width: 220px;
      height: 32px;

      background: #FFFFFF;
      border: 1px solid #D3D5DB;
      box-sizing: border-box;
      border-radius: 3px;
      padding-left: 25px;

    }

    .search-filter:focus {
      outline: none;
    }

    .input-wrapper {
      position: relative;
    }

    .input-icon {
      position: absolute;
      left: 5px;
      font-size: 14px;
      top: 8px;
      color: #a1a1a1;
      cursor: pointer;
    }
  }
`;

const ScreenTitleBar: React.FC<any> = ({ useDarkMode, title, initializeColumnsDialog, rightBeforeConfigureButton, rightAfterConfigureButton, beforeRefreshButton, beforePager,commandsAfterFilterBtn, refresh, children, resizeTitleLabel, closeScreen }) => {
  const isAdditionalCommandsEmpty = typeof rightAfterConfigureButton === 'object' && React.Children.count(rightAfterConfigureButton.props.children) === 0;

  const ifmsListScreenRightStyle: React.CSSProperties = {
    alignItems: 'center',
    marginLeft: 'auto',
    paddingRight: isAdditionalCommandsEmpty ? '81px' : '0',
    display: 'flex',
    height: '100%',
    paddingTop:'1px',
    gap: '8px'
  };

  function doClose() {
    if (closeScreen) {
      closeScreen();
    }
  }

  function doRefresh() {
    if (refresh) {
      refresh();
    }
  }
  return (
    <Screen className={ !useDarkMode ? 'ifms-screen-title-bar' : 'ifms-screen-title-bar-darkmode' }>
      <div className= {!resizeTitleLabel ? "ifms-screen-title-bar-title2" : "ifms-screen-title-bar-title3" } >
        {!resizeTitleLabel && 
          <div id='ifms-screen-title-name' className={ !useDarkMode ? 'oi-doc-title-label' : 'oi-doc-title-label-darkmode-list' }>
            {title}
          </div>
        }
        {resizeTitleLabel && 
          <div id='ifms-screen-title-name' className={ !useDarkMode ? 'oi-doc-title-label2' : 'oi-doc-title-label2-darkmode-list' }>
            {title}
          </div>
        }
      </div>
      {/* <div id ='ifms-screen-title-name' className='ifms-screen-title-bar-title'>{title}</div> */}
      
      {!!children &&
        <>
          {children}
        </>
      }


      {!!beforePager &&
        <>
          {beforePager}
        </>
      }

      {!!commandsAfterFilterBtn &&
        <>
        {commandsAfterFilterBtn}
        </>
      }

      <div className="ifms-common-bar-spacer"></div>

      <div style={ifmsListScreenRightStyle}>
        <CloseButton name="list-close-button" onClick={doClose} onlyIcon />
        {/* <BlackInverseButton style={{marginTop:'3px', marginLeft:'15px'}} name='list-screen-refresh' size="large" onClick={doRefresh} data-tooltip="Refresh" >
          {!useDarkMode ? <FontAwesomeIcon color='#FF3300' icon={faSync} /> :  <FontAwesomeIcon color='#47C83E' icon={faSync} /> }
        </BlackInverseButton>&nbsp;&nbsp; */}
        <RefreshIconButton name='list-screen-refresh'  data-tooltip="Refresh" onClick={doRefresh} />

        {!!rightBeforeConfigureButton &&
          <>{rightBeforeConfigureButton}</>
        }
        {!!initializeColumnsDialog &&
          // <BlackInverseButton name='list-screen-columnOption' onClick={initializeColumnsDialog} size="large" data-tooltip="Column Option" >
          //   {!useDarkMode ? <ConfigureIcon width={20} height={20} /> : <ConfigureIconGreen width={20} height={20} />}
          // </BlackInverseButton>
          <IconButton style={{alignItems: 'center', justifyContent: 'center'}} iconHeight="24px" name='list-screen-columnOption' onClick={initializeColumnsDialog} data-tooltip="Column Option"  icon={!useDarkMode ? ConfigureIcon2 : ConfigureIconDark2 }/>
        }
      </div>
      {!!rightAfterConfigureButton &&
          <>{rightAfterConfigureButton}</>
        }
    </Screen>
  );
};

ScreenTitleBar.defaultProps = {
};

ScreenTitleBar.propTypes = {
  initializeColumnsDialog: PropTypes.func,
  title: PropTypes.string,
  rightBeforeConfigureButton: PropTypes.node,
  rightAfterConfigureButton: PropTypes.node,
  resiezeTitlelabel: PropTypes.bool,
};


export default React.memo(ScreenTitleBar);